<div class="text">
	<div [ngClass]="{'boxed':boxed}">
		<span [ngStyle]="{color:color}">{{beforeFirstIcon}}</span>
		<span *ngIf="iconCount > 0" [ngStyle]="" class="icon inline-icon {{getFirstIcon()}}">&nbsp;</span>
		<span *ngIf="iconCount > 0" [ngStyle]="{'color':color}">{{beforeSecondIcon}}</span>
		<span *ngIf="iconCount > 1" [ngStyle]="" class="icon inline-icon {{getSecondIcon()}}">&nbsp;</span>
		<span *ngIf="iconCount > 1" [ngStyle]="{'color':color}">{{afterSecondIcon}}</span>
		<!--<span *ngIf="!hasIcon()"  [ngStyle]="{color:color}">{{getText()}}&nbsp;</span>-->
	</div>
</div>
